import React from 'react';
import './Policy.css';

export default function TermsOfService() {
  return (
    <div className="policy-page container">
      <h1>Terms of Service</h1>
      <div className="policy-content">
        <p>Last updated: May 06, 2026</p>
        <p>Please read these Terms of Service carefully before using the KOA website.</p>
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using our website, you agree to be bound by these Terms of Service and our Privacy Policy.</p>
        </section>
        <section>
          <h2>2. Use of the Site</h2>
          <p>You agree to use the site only for lawful purposes. You are responsible for maintaining the confidentiality of your account information.</p>
        </section>
        <section>
          <h2>3. Intellectual Property</h2>
          <p>All content on this site, including text, graphics, logos, and images, is the property of KOA and is protected by copyright laws.</p>
        </section>
        <section>
          <h2>4. Limitation of Liability</h2>
          <p>KOA shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the site or products purchased from us.</p>
        </section>
      </div>
    </div>
  );
}
